export default __webpack_public_path__ + "static/media/hands_up.3fc4fc26.svg";